import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import {
    Logout, Menu
} from '@mui/icons-material';
import {
    Avatar, Button, Toolbar as MuiToolbar, Tooltip, Typography
} from '@mui/material';
import {useState, useEffect} from 'react';
import AppBarStyled from './ToolbarStyles';
import KeycloakService from '../../../config/keycloak';
import MenuDropdown from "../../shared/menu-dropdown/MenuDropdown";
import {languageMenuItems, profileMenuItems} from "./ToolbarHelper";
import {KEY_LANGUAGE_SESSION_STORAGE} from "../../../constants/storage";
// import smallLogo2 from "../../../assets/yklogosmall.png";
import PropTypes from "prop-types";
import {getLanguageIcon} from "../../../util/language";
import ProfileMenuDropdown from "../../shared/menu-dropdown/ProfileMenuDropdown";
import {T, useTolgee} from "@tolgee/react";

const Toolbar = ({handleSidebarToggle}) => {
    const [anchorEl, setAnchorEl] = useState({
        profile: null,
        language: null
    });
    const tolgee = useTolgee(['language']);
    const tolgeeLanguage = tolgee.getLanguage();
    const [selectedLanguage, setSelectedLanguage] = useState(tolgeeLanguage || sessionStorage.getItem(KEY_LANGUAGE_SESSION_STORAGE) || 'it');

    useEffect(() => {
        setSelectedLanguage(tolgeeLanguage || 'it');
    }, [tolgeeLanguage]);

    useEffect(() => {
        const handleLanguageChange = (event) => {
            const newLanguage = event?.detail?.language || sessionStorage.getItem(KEY_LANGUAGE_SESSION_STORAGE) || 'it';
            setSelectedLanguage(newLanguage);
        };

        const handleStorageChange = (e) => {
            if (e.key === KEY_LANGUAGE_SESSION_STORAGE) {
                setSelectedLanguage(e.newValue || 'it');
            }
        };

        window.addEventListener('languageChanged', handleLanguageChange);
        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('languageChanged', handleLanguageChange);
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    const handleMenuOpen = (event, key) => {
        setAnchorEl({
            ...anchorEl,
            [key]: event.currentTarget,
        })
    }

    const handleMenuClose = (key) => {
        setAnchorEl({
            ...anchorEl,
            [key]: null,
        })
    }

    const getAvatar = <Avatar
            sx={{
                backgroundColor: "primary.main", mr: "0.25em",
                height: "32px", width: "32px"}}
        >
            {KeycloakService.getNameSurnameInitials()}
        </Avatar>

    return (
        <AppBarStyled position="fixed" color="inherit">
            <MuiToolbar>
                <Box sx={{ flexGrow: 1 }}>
                    <IconButton
                        aria-label="open drawer"
                        edge="start"
                        color={"primary"}
                        onClick={handleSidebarToggle}
                    >
                        <Menu/>
                    </IconButton>
                </Box>
                <Box display="flex">
                    <IconButton
                        sx={{mr: "0.25em"}}
                        size="small"
                        edge="end"
                        aria-controls={"language-menu"}
                        onClick={(e) => handleMenuOpen(e, "language")}
                        color="inherit"
                    >
                        {getLanguageIcon(selectedLanguage)}
                    </IconButton>
                    <Button
                        size="small"
                        edge="end"
                        aria-label="account of current user"
                        aria-controls={"primary-search-account-menu"}
                        aria-haspopup="true"
                        onClick={(e) => handleMenuOpen(e, "profile")}
                        color="inherit"
                    >
                        {getAvatar}
                        <Typography variant="body2">{KeycloakService.getUsername()}</Typography>
                    </Button>
                </Box>
            </MuiToolbar>
            <MenuDropdown anchorEl={anchorEl.language}
                          handleMenuClose={() => handleMenuClose("language")}
                          menuId={"language-menu"}
                          menuItems={languageMenuItems}/>
            <ProfileMenuDropdown anchorEl={anchorEl.profile}
                                 avatar={getAvatar}
                                 handleMenuClose={() => handleMenuClose("profile")}
                                 menuId={"primary-search-account-menu"}
                                 menuItems={profileMenuItems}
                                 username={KeycloakService.getUsername()}
                                 email={KeycloakService.getEmail()}
                                 logoutButton={<Tooltip title={<T keyName={"text-logout"} defaultValue={"Logout"}/>}>
                                     <IconButton onClick={() => KeycloakService.doLogout()}>
                                         <Logout sx={{
                                             marginRight: '0.6em',
                                             rotate: '180deg',
                                         }} />
                                     </IconButton>
                                 </Tooltip>}
                                 placement={"bottom-end"}/>
        </AppBarStyled>
    );
};

Toolbar.propTypes = {
    handleSidebarToggle: PropTypes.func.isRequired
}

export default Toolbar;
